import React from "react";
import Title from "../../ui/Title";

const CareCrisis = () => {
  return (
    <div id="care-crisis" className="scroll-mt-24">
      <Title
        title="Mitigating risks to the care crisis arising due to climate-related emergencies"
        className="mb-6"
      />

      <div className="space-y-4 text-softBlack leading-loose text-base font-normal">
        <p>
          The G20 plays a pivotal role in shaping global responses to
          climate-related challenges, and the establishment of the G20 Working
          Group on Disaster Risk Reduction (DRRWG) in 2023 underscores this
          commitment.
        </p>

        <p>
          The DRRWG’s roadmap aims to integrate risk-reduction measures into
          financing and policy decisions by G20 countries. The roadmap focuses
          on five action areas:
        </p>

        <ul className="list-disc list-outside space-y-2 ml-6">
          <li>Universal coverage or six early warning systems</li>
          <li>Disaster and climate resilient infrastructure</li>
          <li>Disaster recovery, rehabilitation, and reconstruction</li>
          <li>
            Financing frameworks for DRR (disaster recovery, rehabilitation, and
            recovery)
          </li>
          <li>Nature-based solutions and ecosystem-based approaches for DRR</li>
        </ul>

        <p>
          During the Brazilian G20 presidency, the group was developing a sixth
          action area on addressing inequalities and reducing vulnerabilities —
          a critical addition, given the G20’s historical shortfall in
          gender-equality commitments. By addressing and innovating solutions
          towards the gendered impacts of climate change and leveraging gendered
          care responsibilities, resilience can be strengthened in the face of
          environmental challenges.
        </p>

        <p>
          DRRWG’s roadmap also talks about six evidence-based, actionable
          recommendations for crisis management, leveraging gendered care
          responsibilities for solutions in climate-related emergencies,
          recognizing the interconnectedness of climate-related emergencies,
          gender dynamics, and broader crises.
        </p>

        <div className="flex flex-col items-center justify-center my-6">
          <img
            src="/assets/img/pathways.png"
            alt="Six pathways to integrate gendered caregiving into crisis management"
            className=""
          />
          <p className="max-w-[560px] italic">
            Source: Fig. Six pathways to integrate gendered caregiving into
            crisis management support the G20 DRRWP’s Roadmap Action Area 6 —
            Addressing Inequalities and Reducing Vulnerabilities (G20 Working
            Group on Disaster Risk Reduction 2023).
          </p>
        </div>
      </div>
    </div>
  );
};

export default CareCrisis;
